export default __webpack_public_path__ + "static/communities-main-fcac1c362c551662fe251a2bb31c150c.jpg";